import React from "react";
import { Link, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";

export const ExternalLink = ({ url, size, showUrl }: { url: string, size?: string, showUrl?: boolean }) => (
    <Link href={url} title={"Ir a " + url} target="_blank" fontSize={size ? size : "md"} color="blue.600" isExternal>
        {showUrl && url}
        {" "}
        <FontAwesomeIcon icon={faExternalLink} />
    </Link>
);

export const InternalLink = ({
    url,
    text,
    size,
}: {
    url: string;
    text: string;
    size?: string;
}) => (
    <Link href={url}>
        <Text color="blue.600" fontSize={size ? size : "medium"}>
            {text}
        </Text>
    </Link>
);
